import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {Certificate2Service} from 'src/app/services/certificate2.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-certificates-subscriptions-dialog',
  templateUrl: './certificates-subscriptions-dialog.component.html',
  styleUrls: [ './certificates-subscriptions-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class CertificatesSubscriptionsDialogComponent implements OnInit {

  public config: any;
  public matcher = new FormErrorStateMatcher(); // 
  public certificateForm: FormGroup;
  public isEdit: boolean;
  
  public objectImage: any = null;
  public storedImage: any;


  constructor (
    public matDialogRef: MatDialogRef<CertificatesSubscriptionsDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    public _certificateService: Certificate2Service,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log("dialog data: " + JSON.stringify(this.data));
    this.getConfig(this.data.event_id)
    //
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  async getConfig (id: any) {
    this.config = await this._certificateService.getConfig(id)
    if (this.config) {
      // console.log("tem config")
      console.log("this.config: " + JSON.stringify(this.config));
      this.certificateForm = this.createForm(this.config)
    } else {
      // console.log("não tem config")
      this.certificateForm = this.createForm(this.data)
    }
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      event_id: new FormControl(data.event_id),
      event_name: new FormControl(data.event_name),
      isCongress: new FormControl(data.isCongress),
      user_role: new FormControl(data.user_role),
      user_qrCode: new FormControl(data.user_qrCode, [ Validators.required ]),
      user_image_url: new FormControl(data.user_image_url)
    });

    this.storedImage = data.user_image_url;

    return form
  }

  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

}




